import { render, staticRenderFns } from "./ButtonPagination.vue?vue&type=template&id=4f230290&"
import script from "./ButtonPagination.vue?vue&type=script&lang=ts&"
export * from "./ButtonPagination.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonPagination.vue?vue&type=style&index=0&id=4f230290&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports